import { useTranslation } from 'react-i18next'

type Option = {
  key: string
  options: any
}

function Toption({
  options,
  text
}: {
  options?: Option
  text: any
  typeString?: boolean
}) {
  const { t } = useTranslation()
  return t(text, options) as JSX.Element
}

function Tstring(text: string): string {
  const { t } = useTranslation()
  return t(text)
}

/*
  Example:
  1: 'common.required'
  2: { key: 'common.required', options: { value: 1 } }
*/
function T({ text }: { text: any }) {
  switch (typeof text) {
    case 'string':
      return Toption({ text })
    case 'object':
      return Toption({ text: text.key, options: text.options })
    default:
      return null
  }
}

export default T
export { Tstring }
